module.exports = __webpack_public_path__ + "images/b193bf98.www_2_group_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/groupintro/www_2_group_kor.png
// module id = 619
// module chunks = 0